import RootWidgetLayout from './RootWidgetLayout';

export default RootWidgetLayout;
